// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditorHeader-module__editorHeader__MNGnD {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 15px;
  border-bottom: 1px solid #ebebf2;
  position: sticky;
  top: 0;
  height: 49px !important;
  overflow: hidden !important;
}
.EditorHeader-module__editorButtons__RNS_B {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.EditorHeader-module__editorButtons__RNS_B .anticon-message svg {
  width: 20px !important;
  height: 20px !important;
  fill: #748f9e !important;
  stroke: #748f9e !important;
}
.EditorHeader-module__editorButtons__RNS_B .EditorHeader-module__antSwitchInner__MTqY9 > span > svg {
  width: 18px;
  height: 18px;
}
.EditorHeader-module__editorButtons__RNS_B .EditorHeader-module__autoPilotText__DGqOy {
  color: #748f9e;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  /* 150% */
}
.EditorHeader-module__editorButtons__RNS_B > * {
  margin-left: 10px;
}
.EditorHeader-module__editorButtons__RNS_B button:hover svg path {
  fill: #b37feb;
}
.EditorHeader-module__activeButton__V8YfH {
  background-color: #f9f0ff;
}
.EditorHeader-module__activeButton__V8YfH svg path {
  fill: #661eff;
}
.EditorHeader-module__editorProgress__BTcSy {
  display: flex;
  align-items: center;
  position: relative;
}
.EditorHeader-module__editorProgress__BTcSy .loading-container {
  position: absolute;
  top: 0;
  right: -60px;
  transform: translate(-50%, -50%);
}
.EditorHeader-module__loader__Z5Pru,
.EditorHeader-module__loader__Z5Pru:before,
.EditorHeader-module__loader__Z5Pru:after {
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  animation-fill-mode: both;
  animation: EditorHeader-module__bblFadInOut__xUwqc 1.8s infinite ease-in-out;
}
.EditorHeader-module__loader__Z5Pru {
  color: #661eff;
  font-size: 7px;
  position: relative;
  text-indent: -9999em;
  transform: translateZ(0);
  animation-delay: -0.16s;
}
.EditorHeader-module__loader__Z5Pru:before,
.EditorHeader-module__loader__Z5Pru:after {
  content: '';
  position: absolute;
  top: 0;
}
.EditorHeader-module__loader__Z5Pru:before {
  left: -3.5em;
  animation-delay: -0.32s;
}
.EditorHeader-module__loader__Z5Pru:after {
  left: 3.5em;
}
@keyframes EditorHeader-module__bblFadInOut__xUwqc {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}
.EditorHeader-module__restartButton__Jkz4H {
  color: #748f9e;
}
.EditorHeader-module__restartButton__Jkz4H .anticon {
  font-size: 18px !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PlaygroundV3/components/EditorHeader/EditorHeader.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;EACA,MAAA;EACA,uBAAA;EACA,2BAAA;AACF;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;AAJA;EAMI,sBAAA;EACA,uBAAA;EACA,wBAAA;EACA,0BAAA;AACJ;AAGI;EACE,WAAA;EACA,YAAA;AADN;AAdA;EAoBI,cAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAHF,SAAS;AACX;AAQE;EACE,iBAAA;AANJ;AAUI;EAGM,aAAA;AAVV;AAiBA;EACE,yBAAA;AAfF;AAcA;EAIM,aAAA;AAfN;AAoBA;EAEE,aAAA;EACA,mBAAA;EACA,kBAAA;AAnBF;AAeA;EAOI,kBAAA;EACA,MAAA;EACA,YAAA;EACA,gCAAA;AAnBJ;AAuBA;;;EAGE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,4EAAA;AArBF;AAuBA;EACE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,wBAAA;EACA,uBAAA;AArBF;AAuBA;;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;AArBF;AAuBA;EACE,YAAA;EACA,uBAAA;AArBF;AAuBA;EACE,WAAA;AArBF;AAwBA;EACE;;;IAGE,4BAAA;EAtBF;EAwBA;IACE,uBAAA;EAtBF;AACF;AAyBA;EACE,cAAA;AAvBF;AAsBA;EAGI,0BAAA;AAtBJ","sourcesContent":[".editorHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 3px 15px;\n  border-bottom: 1px solid #ebebf2;\n  position: sticky;\n  top: 0;\n  height: 49px !important;\n  overflow: hidden !important;\n}\n.editorButtons {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  :global(.anticon-message svg) {\n    width: 20px !important;\n    height: 20px !important;\n    fill: #748f9e !important;\n    stroke: #748f9e !important;\n  }\n\n  .antSwitchInner {\n    & > span > svg {\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  .autoPilotText {\n    color: #748f9e;\n    text-align: right;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px; /* 150% */\n  }\n\n  // & > :nth-child(1) {\n  //   margin-right: 20px;\n  // }\n  & > * {\n    margin-left: 10px;\n  }\n\n  button {\n    &:hover {\n      svg {\n        path {\n          fill: #b37feb;\n        }\n      }\n    }\n  }\n}\n\n.activeButton {\n  background-color: #f9f0ff;\n  svg {\n    path {\n      fill: #661eff;\n    }\n  }\n}\n\n.editorProgress {\n  // composes: 'display-flex align-items-center';\n  display: flex;\n  align-items: center;\n  position: relative;\n\n  :global(.loading-container) {\n    position: absolute;\n    top: 0;\n    right: -60px;\n    transform: translate(-50%, -50%);\n  }\n}\n\n.loader,\n.loader:before,\n.loader:after {\n  border-radius: 50%;\n  width: 2.5em;\n  height: 2.5em;\n  animation-fill-mode: both;\n  animation: bblFadInOut 1.8s infinite ease-in-out;\n}\n.loader {\n  color: #661eff;\n  font-size: 7px;\n  position: relative;\n  text-indent: -9999em;\n  transform: translateZ(0);\n  animation-delay: -0.16s;\n}\n.loader:before,\n.loader:after {\n  content: '';\n  position: absolute;\n  top: 0;\n}\n.loader:before {\n  left: -3.5em;\n  animation-delay: -0.32s;\n}\n.loader:after {\n  left: 3.5em;\n}\n\n@keyframes bblFadInOut {\n  0%,\n  80%,\n  100% {\n    box-shadow: 0 2.5em 0 -1.3em;\n  }\n  40% {\n    box-shadow: 0 2.5em 0 0;\n  }\n}\n\n.restartButton {\n  color: #748f9e;\n  :global(.anticon) {\n    font-size: 18px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editorHeader": `EditorHeader-module__editorHeader__MNGnD`,
	"editorButtons": `EditorHeader-module__editorButtons__RNS_B`,
	"antSwitchInner": `EditorHeader-module__antSwitchInner__MTqY9`,
	"autoPilotText": `EditorHeader-module__autoPilotText__DGqOy`,
	"activeButton": `EditorHeader-module__activeButton__V8YfH`,
	"editorProgress": `EditorHeader-module__editorProgress__BTcSy`,
	"loader": `EditorHeader-module__loader__Z5Pru`,
	"bblFadInOut": `EditorHeader-module__bblFadInOut__xUwqc`,
	"restartButton": `EditorHeader-module__restartButton__Jkz4H`
};
export default ___CSS_LOADER_EXPORT___;
